import { create } from "zustand";

export type FigmaSession = {
  lastSignIn?: number;
  tokens?: {
    userId: string;
    accessToken: string;
    expiresAt: number;
    refreshToken: string;
  };
};

type FigmaSessionActions = {
  setFigmaSession: ({
    lastSignIn,
    tokens,
  }: {
    lastSignIn: FigmaSession["lastSignIn"];
    tokens: FigmaSession["tokens"];
  }) => void;
  setFigmaLastSignIn: ({
    lastSignIn,
  }: {
    lastSignIn: FigmaSession["lastSignIn"];
  }) => void;
  clearFigmaSession: () => void;
};

const useFigmaSessionStore = create<FigmaSession & FigmaSessionActions>()(
  (set) => ({
    setFigmaSession: ({ lastSignIn, tokens }) =>
      set(() => ({
        lastSignIn,
        tokens,
      })),
    setFigmaLastSignIn: ({ lastSignIn }) => set(() => ({ lastSignIn })),
    clearFigmaSession: () => set(() => ({ tokens: undefined })),
  })
);

export default useFigmaSessionStore;
